import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { Row } from '@/design-system/components/layout';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { NewAccountStackParamList } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import moment from 'moment-timezone';

export interface NewAccountProps {
  onClose: () => void;
  data: any;
  returnData?: any;
  refresh?: () => void;
}

export const NewAccountNativeTwoScreen: React.FC<NewAccountProps> = (props) => {
  const { onClose, data, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    btnView,
    btn,
    textHeaderTitle,
    textHeaderSubTitle,
    modal
  } = sxStyles;

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<NewAccountStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::credit-card-new-account.glossary.new-account')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={modal}>
        <View sx={topHeader}>
          <Icon name="checkCircleBlue" height={108} width={108} />
          <H6 bold sx={textHeaderTitle}>
            {t('card-account-management::credit-card-new-account.instruction-placed.title--new-account-instruction-placed')}
          </H6>
          <TextCaption sx={textHeaderSubTitle}>
            {t('card-account-management::credit-card-new-account.instruction-placed.text--new-account-created')}
          </TextCaption>
        </View>
        <View sx={body}>
          <View sx={{ gap: '$5' }}>
            <View>
              <TextCaption sx={textTitle} semiBold>
                {t('card-account-management::credit-card-new-account.glossary.account-name')}
              </TextCaption>
              <H6 sx={textAtmPin}>{data.name}</H6>
            </View>
            <View>
              <TextCaption sx={textTitle} semiBold>
                {t('card-account-management::credit-card-new-account.glossary.assets')}
              </TextCaption>
              <H6 sx={textAtmPin}>{data.assets.join(' , ')}</H6>
            </View>
            <View sx={horizontalWrapper}>
              <TextBody sx={textLabel}>{t('card-account-management::credit-card-new-account.glossary.instruction-time')}</TextBody>
              <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
            </View>
          </View>
          <View sx={btnView}>
            <UniButton
              sx={btn}
              labelSx={{ color: '$balck' }}
              label={t('card-account-management::general.button--close')}
              onPress={() => {
                refresh();
                navigation.getParent()?.goBack();
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault'
  },
  body: {
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  textLabel: {
    color: '$textSecondary',
    mb: '$1'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btnView: {
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 20
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2',
    textAlign: 'center'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  }
};
